export default {"src":"/_next/static/media/view_quilt.32fa4909.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};